// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__hpNgG","table":"Table_table__SZEna"};